import React from 'react';
import PropTypes from 'prop-types';
import fetchResourceById from 'components/hoc/fetchResourceById';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import { fetchProductMembership } from 'store/actions/product-memberships/fetchProductMemberships';
import ProductMembershipShow from './ProductMembershipShow';

const ProductMembershipShowContainer = (props) => {
    const {
        data,
        history,
        id,
        resource,
        resourceFetchFailed,
        resourceFetchLoading,
    } = props;

    if (resourceFetchLoading) {
        return <LoadingCard />;
    }

    if (resourceFetchFailed) {
        return <ResourceNotFound />;
    }

    if (!data) {
        return null;
    }

    return (
        <ProductMembershipShow
            history={ history }
            id={ id }
            record={ data }
            resource={ resource }
        />
    );
};

ProductMembershipShowContainer.propTypes = {
    data: PropTypes.object,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const fetchValues = {
    resource: 'product-memberships',
    action: fetchProductMembership,
};

export default fetchResourceById(fetchValues)(ProductMembershipShowContainer);



// WEBPACK FOOTER //
// ./src/pages/product-memberships/show/ProductMembershipShowContainer.js